// extracted by mini-css-extract-plugin
module.exports = {"Confirmations":"Confirmations_Confirmations__3A872","Confirmations__Checkbox":"Confirmations_Confirmations__Checkbox__3Xore"};